import type { AuthProvider } from '@refinedev/core';
import { axiosInstance, CREDENTIALS_KEY } from '@/providers/axiosInstance';

export const authProvider: AuthProvider = {
  login: async ({ username, password }) => {
    const credentials = btoa(`${username}:${password}`);

    try {
      await axiosInstance.get('/api/admin/orders', {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
        params: { _start: 0, _end: 1 },
      });

      localStorage.setItem(CREDENTIALS_KEY, credentials);

      return {
        success: true,
        redirectTo: '/',
      };
    } catch {
      return {
        success: false,
        error: {
          name: 'Login Error',
          message: 'Invalid username or password',
        },
      };
    }
  },

  logout: async () => {
    localStorage.removeItem(CREDENTIALS_KEY);

    return {
      success: true,
      redirectTo: '/login',
    };
  },

  check: async () => {
    const credentials = localStorage.getItem(CREDENTIALS_KEY);

    if (credentials) {
      return { authenticated: true };
    }

    return {
      authenticated: false,
      redirectTo: '/login',
    };
  },

  onError: async (error) => {
    if (error.statusCode === 401 || error.statusCode === 403) {
      return {
        logout: true,
        redirectTo: '/login',
        error,
      };
    }

    return { error };
  },

  getIdentity: async () => {
    const credentials = localStorage.getItem(CREDENTIALS_KEY);

    if (!credentials) {
      return undefined;
    }

    const decoded = atob(credentials);
    const username = decoded.split(':')[0] ?? 'admin';

    return {
      id: 1,
      name: username,
    };
  },
};
